import React from 'react';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import { GridContainer } from './shared';

const FormBlock = ({ children, classes, variant, ...rest }) => {
  return (
    <GridContainer
      className={classNames(classes.container, classes[`variant-${variant}`])}
      {...rest}
    >
      {children}
    </GridContainer>
  );
};

FormBlock.defaultProps = {
  variant: 'clear',
};

const styles = theme => ({
  container: {
    width: 'auto',
    margin: 0,
    padding: theme.spacing(0.5),
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  'variant-contained': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
  },
  'variant-clear': {},
});

export default withStyles(styles)(FormBlock);
